import { useEffect, useRef, useState } from "react";

export function Menu({ anchorEl, open, onClose, children, id, className }) {
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        function handleClickOutside(event) {
            // Don't close if click is inside menu or the anchor element
            if (
                open &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !anchorEl?.contains(event.target)
            ) {
                onClose?.();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, [open, onClose, anchorEl]);

    useEffect(() => {
        if (!open || !anchorEl) return;
        const updatePos = () => {
            const rect = anchorEl.getBoundingClientRect();
            const menuWidth = 240; // px
            const margin = 8; // px
            const viewportWidth = window.innerWidth;
            
            // Start by positioning menu to the left of the anchor
            let left = rect.right - menuWidth;
            
            // Ensure menu doesn't go off the left edge
            if (left < margin) {
                left = margin;
            }
            
            // Ensure menu doesn't go off the right edge
            if (left + menuWidth > viewportWidth - margin) {
                left = viewportWidth - menuWidth - margin;
            }
            
            let top = rect.bottom + margin;
            setPosition({ top, left });
        };
        updatePos();
        window.addEventListener("resize", updatePos);
        window.addEventListener("scroll", updatePos, true);
        return () => {
            window.removeEventListener("resize", updatePos);
            window.removeEventListener("scroll", updatePos, true);
        };
    }, [open, anchorEl]);

    if (!open) return null;

    return (
        <div
            id={id}
            ref={menuRef}
            className={`rounded-lg bg-white shadow-lg border p-1 z-[2147483647] transition ease-out duration-150 ${className}`}
            style={{ position: "fixed", top: position.top, left: position.left, minWidth: 240 }}
            // 👇 prevent anchor click → immediate close
            onClick={(e) => e.stopPropagation()}
        >
            {children}
        </div>
    );
}

export function MenuItem({ children, onClick, className }) {
    return (
        <div
            onClick={onClick}
            className={`px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md flex items-center ${className}`}
        >
            {children}
        </div>
    );
}
